export function saveAddresses(state){
  return {
    type: 'SAVE_ADDRESSES',
    payload: state
  }
}